export default "__VITE_ASSET__f7fecd39__"